import _regeneratorRuntime from "/Users/faustomorales/Documents/retinanetjs-example-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/faustomorales/Documents/retinanetjs-example-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/faustomorales/Documents/retinanetjs-example-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/faustomorales/Documents/retinanetjs-example-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/faustomorales/Documents/retinanetjs-example-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/faustomorales/Documents/retinanetjs-example-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/faustomorales/Documents/retinanetjs-example-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/faustomorales/Documents/retinanetjs-example-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as tf from '@tensorflow/tfjs';
import { Zeros } from '@tensorflow/tfjs-layers/dist/initializers'; // tslint:disable-line

import { anchorsForShape, defaultAnchorParameters } from './anchors';

var UpsampleLike =
/*#__PURE__*/
function (_tf$layers$Layer) {
  _inherits(UpsampleLike, _tf$layers$Layer);

  function UpsampleLike() {
    _classCallCheck(this, UpsampleLike);

    return _possibleConstructorReturn(this, _getPrototypeOf(UpsampleLike).call(this, {}));
  }

  _createClass(UpsampleLike, [{
    key: "computeOutputShape",
    value: function computeOutputShape(inputShape) {
      return [inputShape[0][0], inputShape[1][1], inputShape[1][2], inputShape[0][3]];
    }
  }, {
    key: "call",
    value: function call(inputs, _) {
      var _inputs = _slicedToArray(inputs, 2),
          source = _inputs[0],
          target = _inputs[1];

      var targetShape = target.shape;
      return tf.image.resizeNearestNeighbor(source, [targetShape[1], targetShape[2]]);
    }
  }], [{
    key: "className",
    get: function get() {
      return 'UpsampleLike';
    }
  }]);

  return UpsampleLike;
}(tf.layers.Layer);

var PriorProbability =
/*#__PURE__*/
function (_Zeros) {
  _inherits(PriorProbability, _Zeros);

  function PriorProbability() {
    _classCallCheck(this, PriorProbability);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriorProbability).apply(this, arguments));
  }

  return PriorProbability;
}(Zeros); // tslint:disable-line

/** @nocollapse */


PriorProbability.className = 'PriorProbability';
tf.serialization.registerClass(UpsampleLike); // Needed for serialization.

tf.serialization.registerClass(PriorProbability);
/**
 * Represents a RetinaNet model. Rather than creating directly,
 * it is intended to be created using `load()`.
 */

export var RetinaNet =
/*#__PURE__*/
function () {
  function RetinaNet(model, classes, preprocessingMode) {
    var anchorParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultAnchorParameters;

    _classCallCheck(this, RetinaNet);

    var _model$inputs$0$shape = model.inputs[0].shape.slice(1, 3),
        _model$inputs$0$shape2 = _slicedToArray(_model$inputs$0$shape, 2),
        height = _model$inputs$0$shape2[0],
        width = _model$inputs$0$shape2[1]; // tslint:disable-next-line


    if (height === -1 || width === -1) {
      throw new Error('RetinaNetJS only supports fixed input sizes.');
    } // tslint:disable-next-line


    if (preprocessingMode !== 'tf' && preprocessingMode !== 'caffe') {
      throw new Error('preprocessingMode must be either `tf` or `caffe`.');
    }

    this.width = width;
    this.height = height;
    this.model = model;
    this.classes = classes;
    this.preprocessingMode = preprocessingMode;
    this.anchorParams = anchorParams;
  }
  /**
   * Computes predictions. We currently do not support class-specific filtering.
   * When non-max suppression is applied, it will be across all boxes, regardless of class.
   *
   * @param img The image object on which to run object detection
   * @param threshold The prediction threshold
   * @param nmsThreshold The non-max suppresion IoU threshold
   */


  _createClass(RetinaNet, [{
    key: "detect",
    value: function () {
      var _detect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(img) {
        var _this = this;

        var threshold,
            nmsThreshold,
            _tf$tidy,
            _tf$tidy2,
            X,
            padX,
            padY,
            y,
            _tf$tidy3,
            _tf$tidy4,
            coords,
            classification,
            selected,
            detections,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                threshold = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0.5;
                nmsThreshold = _args.length > 2 && _args[2] !== undefined ? _args[2] : 0.5;
                // Build model input from image
                _tf$tidy = tf.tidy(function () {
                  var imageTensor = !(img instanceof tf.Tensor) ? tf.browser.fromPixels(img) : img;
                  return _this.handleImageTensor(imageTensor);
                }), _tf$tidy2 = _slicedToArray(_tf$tidy, 3), X = _tf$tidy2[0], padX = _tf$tidy2[1], padY = _tf$tidy2[2]; // Run inference

                y = this.model.predict(X);
                _tf$tidy3 = tf.tidy(function () {
                  var _y$map = y.map(function (t) {
                    return t.squeeze([0]);
                  }),
                      _y$map2 = _slicedToArray(_y$map, 2),
                      boxDeltas = _y$map2[0],
                      classScores = _y$map2[1];

                  var anchorBoxes = anchorsForShape(_this.model.inputs[0].shape.slice(1, 3), _this.anchorParams);
                  var mean = [0, 0, 0, 0];
                  var std = [0.2, 0.2, 0.2, 0.2];
                  var width = anchorBoxes.slice([0, 2], [-1, 1]).sub(anchorBoxes.slice([0, 0], [-1, 1]));
                  var height = anchorBoxes.slice([0, 2], [-1, 1]).sub(anchorBoxes.slice([0, 0], [-1, 1]));
                  var x1y1x2y2 = tf.concat([0, 1, 2, 3].map(function (i) {
                    return anchorBoxes.slice([0, i], [-1, 1]).add(boxDeltas.slice([0, i], [-1, 1]).mul(std[i]).add(mean[i]).mul(i % 2 === 0 ? width : height));
                  }), 1); // TODO: Add support for class-specific filtering and turning nms on and off, just
                  // like in retinanet.

                  return [x1y1x2y2, classScores];
                }), _tf$tidy4 = _slicedToArray(_tf$tidy3, 2), coords = _tf$tidy4[0], classification = _tf$tidy4[1];
                _context.next = 7;
                return tf.image.nonMaxSuppressionAsync(coords, classification.max(1, false), 300, nmsThreshold, threshold);

              case 7:
                selected = _context.sent;
                detections = tf.tidy(function () {
                  var classificationNms = classification.gather(selected);
                  var coordsNms = coords.gather(selected).div([_this.width - padX, _this.height - padY, _this.width - padX, _this.height - padY]);
                  var x1y1x2y2ls = tf.concat([coordsNms, classificationNms.argMax(1).expandDims(1).cast('float32'), classificationNms.max(1, true)], 1).arraySync();
                  return x1y1x2y2ls.map(function (r) {
                    var _r = _slicedToArray(r, 6),
                        x1 = _r[0],
                        y1 = _r[1],
                        x2 = _r[2],
                        y2 = _r[3],
                        labelIdx = _r[4],
                        score = _r[5];

                    return {
                      label: _this.classes[labelIdx],
                      score: score,
                      x1: x1,
                      x2: x2,
                      y1: y1,
                      y2: y2
                    };
                  });
                });
                X.dispose();
                y.map(function (t) {
                  return t.dispose();
                });
                selected.dispose();
                return _context.abrupt("return", detections);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function detect(_x) {
        return _detect.apply(this, arguments);
      }

      return detect;
    }()
    /**
     * Remove the model from memory.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this.model.dispose();
    }
  }, {
    key: "handleImageTensor",
    value: function handleImageTensor(imageTensor) {
      var _this2 = this;

      return tf.tidy(function () {
        var inputHeight = imageTensor.shape[0];
        var inputWidth = imageTensor.shape[1];
        var _ref = [_this2.height, _this2.width],
            outputHeight = _ref[0],
            outputWidth = _ref[1];
        var scale = Math.min(outputHeight / inputHeight, outputWidth / inputWidth);
        var padY = outputHeight - Math.round(scale * inputHeight);
        var padX = outputWidth - Math.round(scale * inputWidth);
        var scaledTensor = scale === 1 ? imageTensor : imageTensor.resizeBilinear([Math.round(scale * inputHeight), Math.round(scale * inputWidth)]);
        var paddedTensor = padX === 0 && padY === 0 ? scaledTensor : scaledTensor.pad([[0, padY], [0, padX], [0, 0]]);
        var normedTensor = _this2.preprocessingMode === 'tf' ? paddedTensor.sub(127.5).div(127.5) : paddedTensor.sub(tf.tensor3d([[[103.939, 116.779, 123.68]]]));
        return [normedTensor.expandDims(0).cast('float32'), padX, padY];
      });
    }
  }]);

  return RetinaNet;
}();
/**
 *
 * @param modelPath The path to the model or a `tf.io.IOHandler` object
 * @param classes The list of detected classes
 * @param preprocessingMode One of `tf` or `caffe`. Check the `preprocess_images`
 *   method of your backbone to see which you should use.
 * @param onProgress A callback to report progress
 * @param anchorParams The anchor parameters for your model
 */

export function load(_x2, _x3, _x4, _x5) {
  return _load.apply(this, arguments);
}

function _load() {
  _load = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(modelPath, classes, preprocessingMode, onProgress) {
    var anchorParams,
        tfOnProgress,
        model,
        detector,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            anchorParams = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : defaultAnchorParameters;

            tfOnProgress = function tfOnProgress(progress) {
              return onProgress(0.9 * progress, 'Downloading');
            };

            _context3.next = 4;
            return tf.loadLayersModel(modelPath, {
              onProgress: tfOnProgress,
              strict: false
            });

          case 4:
            model = _context3.sent;
            detector = new RetinaNet(model, classes, preprocessingMode, anchorParams);
            if (onProgress) onProgress(0.92, 'Building'); // tslint:disable-line

            setTimeout(
            /*#__PURE__*/
            _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return detector.detect(tf.ones([100, 100, 3]));

                    case 2:
                      if (onProgress) onProgress(1.0, 'Finished'); // tslint:disable-line

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })), 100);
            return _context3.abrupt("return", detector);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _load.apply(this, arguments);
}